import { lazy } from 'react'
// const AddNotifications = lazy(() =>
//   import('../../views/admin/AddNotifications')
// )
// const AdminDashboard = lazy(() => import('../../views/admin/AdminDashboard'))
const AdminOrders = lazy(() => import('../../views/controlOrders/AdminOrders'))
const AdminOrderDetails = lazy(() =>
  import('../../views/controlOrders/AdminOrderDetails')
)
// const ProductProperty = lazy(() => import('../../views/admin/ProductProperty'))
// const ProductColors = lazy(() => import('../../views/admin/ProductColors'))
// const AddProduct = lazy(() => import('../../views/admin/AddProduct'))
// const Products = lazy(() => import('../../views/admin/Products'))
// const EditProduct = lazy(() => import('../../views/admin/EditProduct'))
// const AddBanner = lazy(() => import('../../views/admin/AddBanner'))
// const Reklam = lazy(() => import('../../views/admin/Reklam'))
// const AddSeller = lazy(() => import('../../views/admin/AddSeller'))
// const EditShop = lazy(() => import('../../views/admin/EditShop'))
// const AddUser = lazy(() => import('../../views/admin/AddUser'))
// const Customers = lazy(() => import('../../views/admin/Customers'))
// const Shops = lazy(() => import('../../views/admin/Shops'))
// const PaymentRequest = lazy(() => import('../../views/admin/PaymentRequest'))
// const DeactiveSellers = lazy(() => import('../../views/admin/DeactiveSellers'))
// const SellerRequest = lazy(() => import('../../views/admin/SellerRequest'))
// const SellerDetails = lazy(() => import('../../views/admin/SellerDetails'))
// const ChatSeller = lazy(() => import('../../views/admin/ChatSeller'))
// const OrderDetails = lazy(() => import('../../views/admin/OrderDetails'))
// const AddCoupon = lazy(() => import('../../views/admin/AddCoupon'))

export const adminOrdersRoutes = [
  {
    path: 'orderAdmin/orders',
    element: <AdminOrders />,
    role: 'orderAdmin',
  },
  {
    path: 'orderAdmin/order/details/:orderId',
    element: <AdminOrderDetails />,
    role: 'orderAdmin',
  },
]
